<!-- h-auto overrides login-background's fixed height so the page can grow and
     scroll when the mobile keyboard shrinks the viewport (min-h-dvh keeps it
     full-screen otherwise) -->
<div
    class="px-4 py-8 sm:px-6 sm:py-20 md:px-20 flex items-center justify-center login-background h-auto min-h-dvh">
    <div
        class="px-6 sm:px-8 md:px-12 lg:px-16 py-8 sm:py-12 flex flex-col items-center gap-6 sm:gap-8 w-full backdrop-blur-xl rounded-2xl bg-white/30 border border-white/40 shadow-xl max-w-lg">
        <div class="flex flex-col items-center gap-4 w-full">
            <img [src]="logoUrl" alt="Company logo" class="h-14 w-14 object-contain" />
            <!-- <svg xmlns="http://www.w3.org/2000/svg" class="h-14 w-14" width="33" height="32" viewBox="0 0 33 32"
                fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M7.09219 2.87829C5.94766 3.67858 4.9127 4.62478 4.01426 5.68992C7.6857 5.34906 12.3501 5.90564 17.7655 8.61335C23.5484 11.5047 28.205 11.6025 31.4458 10.9773C31.1517 10.087 30.7815 9.23135 30.343 8.41791C26.6332 8.80919 21.8772 8.29127 16.3345 5.51998C12.8148 3.76014 9.71221 3.03521 7.09219 2.87829ZM28.1759 5.33332C25.2462 2.06 20.9887 0 16.25 0C14.8584 0 13.5081 0.177686 12.2209 0.511584C13.9643 0.987269 15.8163 1.68319 17.7655 2.65781C21.8236 4.68682 25.3271 5.34013 28.1759 5.33332ZM32.1387 14.1025C28.2235 14.8756 22.817 14.7168 16.3345 11.4755C10.274 8.44527 5.45035 8.48343 2.19712 9.20639C2.0292 9.24367 1.86523 9.28287 1.70522 9.32367C1.2793 10.25 0.939308 11.2241 0.695362 12.2356C0.955909 12.166 1.22514 12.0998 1.50293 12.0381C5.44966 11.161 11.0261 11.1991 17.7655 14.5689C23.8261 17.5991 28.6497 17.561 31.9029 16.838C32.0144 16.8133 32.1242 16.7877 32.2322 16.7613C32.2441 16.509 32.25 16.2552 32.25 16C32.25 15.358 32.2122 14.7248 32.1387 14.1025ZM31.7098 20.1378C27.8326 20.8157 22.5836 20.5555 16.3345 17.431C10.274 14.4008 5.45035 14.439 2.19712 15.1619C1.475 15.3223 0.825392 15.5178 0.252344 15.7241C0.250782 15.8158 0.25 15.9078 0.25 16C0.25 24.8366 7.41344 32 16.25 32C23.6557 32 29.8862 26.9687 31.7098 20.1378Z"
                    class="fill-surface-0" />
            </svg> -->
            <div class="flex flex-col gap-2 w-full">
                <div class="text-center text-2xl lg:text-3xl font-medium text-surface-900 leading-tight">
                    Welcome Back
                </div>
                <div class="text-center text-sm text-surface-500">Sign in to your account</div>
                @if(isError){
                    <p-message severity="error">{{errorMsg}}</p-message>
                }
                <!-- <div class="text-center flex flex-col ">
                    <span class="text-surface-500">Don't have an account? </span>
                    <a class="text-surface-500 cursor-pointer hover:text-surface-700 underline">Sign up</a>
                </div> -->
            </div>
        </div>

        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-6 w-full">
            <div class="flex flex-col gap-2 w-full">
                <label for="username" class="form-label">Username</label>
                <p-iconfield icon-position="left">
                    <p-inputicon class="pi pi-user !text-surface-500"></p-inputicon>
                    <input
                        #usernameInput
                        id="username"
                        type="text"
                        pInputText
                        class="w-full h-14 text-[16px] sm:text-lg px-4"
                        formControlName="username"
                        placeholder="Username"
                        autocomplete="username"
                        appOnlyUppercase
                        appAlphaNumeric
                        autofocus />
                </p-iconfield>

                <app-field-error [control]="loginForm.get('username')" fieldName="username" inputId="username" />
            </div>

            <div class="flex flex-col gap-2 w-full">
                <label for="password" class="form-label">Password</label>
                <p-iconfield iconPosition="left">
                    <p-inputicon class="pi pi-lock !text-surface-500"></p-inputicon>
                    <p-password
                        inputId="password"
                        formControlName="password"
                        class="w-full h-14 text-lg"
                        inputStyleClass="text-[16px] sm:text-lg"
                        placeholder="Password"
                        toggleMask="true"
                        [feedback]="false"
                        [fluid]="true"
                        autocomplete="current-password"
                        [minlength]="minPasswordLength"
                        [maxlength]="maxPasswordLength">
                    <ng-template #hideicon>
                        <i class="pi pi-eye p-password-toggle-mask-icon text-surface-500"></i>
                    </ng-template>

                    <ng-template #showicon>
                        <i class="pi pi-eye-slash p-password-toggle-mask-icon text-surface-500"></i>
                    </ng-template>

                    </p-password>
                </p-iconfield>

                <app-field-error
                    [control]="loginForm.get('password')"
                    fieldName="password"
                    inputId="password"
                    [messages]="passwordMessages" />
            </div>

            <!-- Submit -->
            <button
                pButton
                type="submit"
                [disabled]="isLoading"
                [loading]="isLoading"
                class="w-full h-14 rounded-3xl">
                <span pButtonLabel>{{ isLoading ? 'Signing In...' : 'Sign In' }}</span>
            </button>
        </form>
        <!-- Hidden until the forgot-password flow is implemented -->
        <!-- <a class="text-surface-500 cursor-pointer hover:text-surface-700">Forgot Password?</a> -->
    </div>
</div>
